module.exports = __webpack_public_path__ + "img/pir-brick-vertical.1551c266.svg";